import React, { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const DEVICE_KEY = "astrofate_device";
const votedKey = (kind, id) => `astrofate_accurate_${kind}_${id || "latest"}`;

const deviceKey = () => {
  try {
    let k = localStorage.getItem(DEVICE_KEY);
    if (!k) { k = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(DEVICE_KEY, k); }
    return k;
  } catch { return "anon"; }
};

// "This was accurate" — one tap, one vote, and the running count becomes the
// strongest proof on the site.
export default function AccuracyVote({ kind = "report", reportId = null, compact = false, label = "This was accurate" }) {
  const [voted, setVoted] = useState(false);
  const [total, setTotal] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    try { setVoted(!!localStorage.getItem(votedKey(kind, reportId))); } catch { /* ignore */ }
    axios.get(`${API}/public/accuracy-count`).then(r => setTotal(r.data?.total ?? null)).catch(() => {});
  }, [kind, reportId]);

  const vote = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/feedback/accurate`, {
        kind, report_id: reportId, device_key: deviceKey(),
      }, { withCredentials: true });
      setTotal(data.total); setVoted(true);
      try { localStorage.setItem(votedKey(kind, reportId), "1"); } catch { /* ignore */ }
    } catch { /* silent — feedback must never block the reading */ }
    setBusy(false);
  };

  return (
    <div data-testid={`accuracy-vote-${kind}`} style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
      <button data-testid={`accuracy-vote-btn-${kind}`} onClick={vote} disabled={voted || busy}
        style={{
          display: "inline-flex", alignItems: "center", gap: "7px", cursor: voted ? "default" : "pointer",
          background: voted ? "rgba(34,197,94,0.14)" : "rgba(255,255,255,0.04)",
          border: `1px solid ${voted ? "rgba(34,197,94,0.4)" : "rgba(255,209,102,0.3)"}`,
          color: voted ? "#86efac" : "#FFD166", borderRadius: "50px",
          padding: compact ? "6px 13px" : "9px 17px", fontSize: compact ? "0.76rem" : "0.82rem", fontWeight: 700,
          transition: "background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease",
        }}>
        <CheckCircle2 size={compact ? 13 : 15} /> {voted ? "Marked accurate — thank you" : label}
      </button>
      {total > 0 && (
        <span data-testid={`accuracy-count-${kind}`} style={{ color: "rgba(255,255,255,0.45)", fontSize: "0.76rem" }}>
          {total.toLocaleString()} reading{total === 1 ? "" : "s"} marked accurate by clients
        </span>
      )}
    </div>
  );
}
